import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import './to-be-aware.scss';

const ToBeAware = ({ content }: any) => {
    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
                <p>{children}</p>
            ),
            [BLOCKS.OL_LIST]: (_node: any, children: any) => (
                <ol type="1">{children}</ol>
            ),
            [INLINES.HYPERLINK]: (_node: any, children: any) => {
                return (
                    <a
                        href={_node?.data?.uri}
                        rel="noopener noreferrer"
                        target={
                            _node?.data?.uri?.includes('www') ||
                            _node?.data?.uri?.includes('https')
                                ? '_blank'
                                : '_self'
                        }
                        title={children}
                    >
                        {children}
                    </a>
                );
            },
        },
    };

    return (
        <div className="a-to-be-aware">
            <div>
                {content &&
                    content.raw &&
                    documentToReactComponents(
                        JSON.parse(content?.raw),
                        options
                    )}
            </div>
        </div>
    );
};

export default ToBeAware;
